// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"3fab8702","453":"593125b2","934":"dfac7535"}[chunkId] + ".chunk.js";
};